import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Button, Form, FormGroup, Label } from 'reactstrap';

import { MAINTENANCE_SERVICE_ORDER_STATUS } from '../../../../config/constants';

import { enumToSelectOptions } from '../../../../utils/enum';

const ChangeMaintenanceServiceOrderStatusForm = ({
  currentStatus,
  handleProcess,
  onCancel,
}) => {
  const [status, setStatus] = useState(null);
  const [processing, setProcessing] = useState(false);

  const statusOptions = useMemo(
    () =>
      enumToSelectOptions(MAINTENANCE_SERVICE_ORDER_STATUS).filter(
        ({ value }) => value !== currentStatus,
      ),
    [currentStatus],
  );

  const currentStatusData = useMemo(
    () =>
      Object.values(MAINTENANCE_SERVICE_ORDER_STATUS).find(
        ({ value }) => value === currentStatus,
      ),
    [currentStatus],
  );

  useEffect(() => {
    if (currentStatus !== MAINTENANCE_SERVICE_ORDER_STATUS.DONE.value) {
      setStatus(MAINTENANCE_SERVICE_ORDER_STATUS.DONE);
    } else {
      setStatus(null);
    }
  }, [currentStatus]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!status || !status.value || processing) {
      return;
    }

    try {
      setProcessing(true);

      await handleProcess({
        status,
      });
    } finally {
      setProcessing(false);
    }
  };

  return (
    <Form onSubmit={handleSubmit}>
      {currentStatusData && (
        <FormGroup>
          <Label>Estado actual</Label>

          <div>
            <span className={`badge badge-${currentStatusData.color}`}>
              {currentStatusData.label}
            </span>
          </div>
        </FormGroup>
      )}

      <FormGroup>
        <Label for="maintenance-service-order-status">Nuevo estado</Label>

        <Select
          inputId="maintenance-service-order-status"
          name="maintenanceServiceOrderStatus"
          value={status}
          options={statusOptions}
          onChange={setStatus}
          placeholder="Seleccione un estado"
          noOptionsMessage={() => 'No hay estados disponibles'}
          isDisabled={processing}
        />
      </FormGroup>

      <div className="d-flex justify-content-end">
        <Button
          type="button"
          color="secondary"
          className="mr-2"
          onClick={onCancel}
          disabled={processing}
        >
          Cancelar
        </Button>

        <Button
          type="submit"
          color="primary"
          disabled={!status || !status.value || processing}
        >
          {processing ? (
            <>
              <i className="fa fa-spinner fa-spin mr-1" />
              Procesando...
            </>
          ) : (
            <>
              <i className="fa fa-check mr-1" />
              Cambiar estado
            </>
          )}
        </Button>
      </div>
    </Form>
  );
};

ChangeMaintenanceServiceOrderStatusForm.propTypes = {
  currentStatus: PropTypes.string,
  handleProcess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

ChangeMaintenanceServiceOrderStatusForm.defaultProps = {
  currentStatus: null,
};

export default ChangeMaintenanceServiceOrderStatusForm;
